jQuery("#return-top").click(function() {
  jQuery("html, body").animate({ scrollTop: 0 }, "slow");
  return false;
});

jQuery("#return-top").keypress(function(e) {
    if (event.keyCode === 32 || event.keyCode === 13) {
        event.preventDefault();
        jQuery("#return-top").click();
    }
});